/**
 * Mensajes para los rechazos de `POST /api/auth/google`.
 *
 * El backend (security-remediation fase 3) dejó de fusionar en silencio una
 * cuenta de correo y contraseña con la identidad de Google que llega con el mismo
 * email: ahora responde 409 con un `code`. Login y registro comparten este mapa
 * para que el mismo rechazo diga lo mismo en las dos pantallas.
 */

export interface RespuestaErrorGoogle {
    code?: string;
    message?: string;
}

const MENSAJES_POR_CODIGO: Record<string, string> = {
    CUENTA_EXISTENTE_SIN_GOOGLE:
        'Ya existe una cuenta con este correo creada con contraseña. Inicia sesión con tu correo y tu contraseña y, después, vincula Google desde Configuración.',
    GOOGLE_ID_NO_COINCIDE:
        'Este correo ya está vinculado a otra cuenta de Google. Entra con la cuenta de Google que usaste al registrarte o con tu correo y tu contraseña.',
    GOOGLE_NO_CONFIGURADO:
        'El acceso con Google no está disponible en este momento. Entra con tu correo y tu contraseña o inténtalo más tarde.',
};

// El 403 de cuenta bloqueada no trae `code`, solo el mismo `message` que /login
// (con los minutos restantes). Este texto solo cubre una respuesta sin mensaje.
const MENSAJE_CUENTA_BLOQUEADA =
    'Tu cuenta está bloqueada temporalmente por seguridad. Inténtalo de nuevo más tarde.';

export function mensajeErrorGoogle(
    estado: number,
    cuerpo: RespuestaErrorGoogle | null | undefined,
    mensajePorDefecto: string
): string {
    const codigo = cuerpo?.code;
    if (codigo && MENSAJES_POR_CODIGO[codigo]) return MENSAJES_POR_CODIGO[codigo];
    if (cuerpo?.message) return cuerpo.message;
    if (estado === 403) return MENSAJE_CUENTA_BLOQUEADA;
    return mensajePorDefecto;
}
